import { render } from "./text2.vue?vue&type=template&id=a390c742&scoped=true"
import script from "./text2.vue?vue&type=script&lang=js"
export * from "./text2.vue?vue&type=script&lang=js"

import "./text2.vue?vue&type=style&index=0&id=a390c742&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a390c742"]])

export default __exports__